import { ServiceFetch } from '../service-fetch'

export default class ProductBarcodeModel extends ServiceFetch {
    getProductBarcodeBy = (data) => this.authFetch({
        url: 'product-barcode/getProductBarcodeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}